export const isZero = (x) => x === 0;
